export default __webpack_public_path__ + "static/media/dm.3f583080.svg";